export const rightContent = {
  hidden: {
    opacity: 0,
    x: "-100vw",
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 3.5,
      type: "spring",
      bounce: 0.2,
    },
  },
};
export const listVariation = {
  hidden: {
    opacity: 0,
    scale: 0,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      type: "spring",
      mass: 0.4,
      damping: 8,
      bounce: 0.4,
      stiffness: 180,
    },
  },
};
export const leftContent = {
  hidden: {
    opacity: 0,
    y: "-150px",
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 2,
      type: "spring",
    },
  },
  exit: {
    y: "150px",
    transition: {
      duration: 1,
    },
  },
};
export const highlightVariant = {
  hidden: {
    color: "black",
  },
  visible: {
    color: "rgb(255, 174, 0)",
    transition: {
      delay: 3,
      duration: 2,
    },
  },
};
export const container = {
  visible: {
    transition: {
      //higher mass means moves slower
      mass: 0.4,
      //strnght of the opposing force
      damping: 8,
      when: "beforeChildren",
      staggerChildren: 0.3,
    },
  },
};
export const box = {
  hidden: {
    opacity: 0,
    scale: 0,
  },
  visible: {
    opacity: 1,

    scale: 1,
    transition: {
      duration: 1,
    },
  },
  rotate180deg: {
    rotate: 180,
    transition: {
      duration: 0.3,
    },
  },
  rotate90deg: {
    rotate: 0,
    transition: {
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    scale: 0,
    transition: {
      duration: 0.8,
    },
  },
};
export const box1 = {
  hidden: {
    opacity: 0,

    scale: 0,
  },
  visible: {
    opacity: 1,
    originX: 0,
    scale: 1,
    transition: {
      duration: 1,
    },
  },

  exit: {
    opacity: 0,
    y: "150px",
    transition: {
      duration: 0.8,
    },
  },
};
